import React, { useRef, useState } from "react";
import cover from "../../assets/images/profile-info-cover.png";
import profile from "../../assets/images/profile-info-profile.png";
import faq from "../../data/faq.json";
import Icons from "../Helpers/Icons";
import Layout from "../Partials/Layout";
import PersonalInfoTab from "./Tabs/PersonalInfoTab";
import NotificationSettingTab from "./Tabs/NotificationSettingTab";
import FamilyGroupTab from "./Tabs/FamilyGroupTab";
import EventRemindersTab from "./Tabs/EventRemindersTab";
import AccountPreferencesTab from "./Tabs/AccountPreferenceTab";
import ConnectQrTab from "./Tabs/ConnectQRTab";
// import PaymentMathodsTab from "./Tabs/PaymentMathodsTab";
// import FaqTab from "./Tabs/FaqTab";
// import TermsConditionTab from "./Tabs/TermsConditionTab";

export default function Settings() {

  const tabHandler = (value) => {
    setTab(value);
  };
  const [profileImg, setProfileImg] = useState(profile);
  const [coverImg, setCoverImg] = useState(cover);

  // profile img
  const profileImgInput = useRef(null);
  const browseProfileImg = () => {
    profileImgInput.current.click();
  };
  const profileImgChangHandler = (e) => {
    if (e.target.value !== "") {
      const imgReader = new FileReader();
      imgReader.onload = (event) => {
        setProfileImg(event.target.result);
      };
      imgReader.readAsDataURL(e.target.files[0]);
    }
  };
  // cover img
  const coverImgInput = useRef(null);
  const browseCoverImg = () => {
    coverImgInput.current.click();
  };
  const coverImgChangHandler = (e) => {
    if (e.target.value !== "") {
      const imgReader = new FileReader();
      imgReader.onload = (event) => {
        setCoverImg(event.target.result);
      };
      imgReader.readAsDataURL(e.target.files[0]);
    }
  };

  // fab tab
  const faqData = faq.datas;

    const tabs = [
    {
      id: 1,
      name: "account",
      title: "My Account",
      icon: "profile",
      comp: <PersonalInfoTab
        profileImg={profileImg}
        coverImg={coverImg}
        browseProfileImg={browseProfileImg}
        profileImgInput={profileImgInput}
        profileImgChangHandler={profileImgChangHandler}
        coverImgChangHandler={coverImgChangHandler}
        browseCoverImg={browseCoverImg}
        coverImgInput={coverImgInput}
      />,
    },
    {
      id: 2,
      name: "family",
      title: "Family / Group",
      icon: "people-two",
      comp: <FamilyGroupTab />,
    },
    {
      id: 3,
      name: "notification",
      title: "Notification Settings",
      icon: "notification-setting",
      comp: <NotificationSettingTab />,
    },
    {
      id: 4,
      name: "events",
      title: "Event Reminders",
      icon: "reminder",
      comp: <EventRemindersTab />,
    },
    {
      id: 5,
      name: "preferenece",
      title: "Account Preferences",
      icon: "settings",
      comp: <AccountPreferencesTab />,
    },
    {
      id: 6,
      name: "qr",
      title: "Connect QR",
      icon: "login-activity",
      comp: <ConnectQrTab />,
    },
  ];

  const [tab, setTab] = useState(tabs[0].name);

  return (
    <>
      <Layout>
        <div className="settings-wrapper w-full relative mb-10">
          <div className="main-wrapper w-full">
            {/* heading */}
            <div className="heading w-full mb-6">
              <h1 className="text-26 font-bold text-dark-gray dark:text-white antialiased">
                Settings
              </h1>
            </div>
            <div className="content-container w-full pt-10 rounded-2xl bg-white dark:bg-dark-white  ">
              <div className="content-heading w-full mb-8 lg:px-10 px-4">
                <h1 className="text-xl font-bold text-dark-gray dark:text-white antialiased">
                  Personal Information
                </h1>
              </div>
              <div className="content-body w-full lg:flex lg:px-10 px-4">
                <div className="content-tab-items lg:w-[230px] w-full mr-2">
                  <ul className="overflow-hidden mb-10 lg:mb-0">
                    {tabs.map((item) => (
                      <li
                        key={item?.id + item?.name}
                        onClick={() => tabHandler(item?.name)}
                        className={`flex lg:space-x-4 space-x-2 hover:text-purple transition-all duration-300 ease-in-out items-center cursor-pointer lg:mb-11 mb-2 mr-6 lg:mr-0 float-left lg:float-none overflow-hidden ${
                          tab === item?.name
                            ? "text-purple"
                            : " text-thin-light-gray"
                        }`}
                      >
                        <div>
                          <Icons name={item?.icon} />
                        </div>
                        <div>
                          <p className="text-18 tracking-wide">{item?.title}</p>
                        </div>
                      </li>
                    ))}
                    {/* <li
                      onClick={() => tabHandler("payment")}
                      className={`flex lg:space-x-4 space-x-2 hover:text-purple transition-all duration-300 ease-in-out items-center cursor-pointer lg:mb-11 mb-2 mr-6 lg:mr-0 float-left lg:float-none overflow-hidden ${
                        tab === "payment"
                          ? "text-purple"
                          : " text-thin-light-gray"
                      }`}
                    >
                      <div>
                        <Icons name="bank-card" />
                      </div>
                      <div>
                        <p className="text-18 tracking-wide">Payment Method</p>
                      </div>
                    </li>
                    <li
                      onClick={() => tabHandler("notification")}
                      className={`flex lg:space-x-4 space-x-2 hover:text-purple transition-all duration-300 ease-in-out items-center cursor-pointer lg:mb-11 mb-2 mr-6 lg:mr-0 float-left lg:float-none overflow-hidden ${
                        tab === "notification"
                          ? "text-purple"
                          : " text-thin-light-gray"
                      }`}
                    >
                      <div>
                        <Icons name="notification-setting" />
                      </div>
                      <div>
                        <p className="text-18 tracking-wide">
                          Notification Settings
                        </p>
                      </div>
                    </li>
                    <li
                      onClick={() => tabHandler("faq")}
                      className={`flex lg:space-x-4 space-x-2 hover:text-purple transition-all duration-300 ease-in-out items-center cursor-pointer lg:mb-11 mb-2 mr-6 lg:mr-0 float-left lg:float-none overflow-hidden ${
                        tab === "faq" ? "text-purple" : " text-thin-light-gray"
                      }`}
                    >
                      <div>
                        <Icons name="block-question" />
                      </div>
                      <div>
                        <p className="text-18 tracking-wide">FAQ</p>
                      </div>
                    </li>
                    <li
                      onClick={() => tabHandler("terms")}
                      className={`flex lg:space-x-4 space-x-2 hover:text-purple transition-all duration-300 ease-in-out items-center cursor-pointer lg:mb-11 mb-2 mr-6 lg:mr-0 float-left lg:float-none overflow-hidden ${
                        tab === "terms"
                          ? "text-purple"
                          : " text-thin-light-gray"
                      }`}
                    >
                      <div>
                        <Icons name="page-right" />
                      </div>
                      <div>
                        <p className="text-18 tracking-wide">
                          Terms and Conditions
                        </p>
                      </div>
                    </li> */}
                  </ul>
                </div>
                <div className="w-[1px] bg-[#E3E4FE] dark:bg-[#a7a9b533]  mr-10"></div>
                <div className="content-body-items flex-1">
                  <div className='tab-item'>
                    {tabs.filter((item) => item.name === tab)[0].comp}
                  </div>
                  {/* {tab === "account" && (
                    <div className="tab-item">
                      <PersonalInfoTab
                        profileImg={profileImg}
                        coverImg={coverImg}
                        browseProfileImg={browseProfileImg}
                        profileImgInput={profileImgInput}
                        profileImgChangHandler={profileImgChangHandler}
                        coverImgChangHandler={coverImgChangHandler}
                        browseCoverImg={browseCoverImg}
                        coverImgInput={coverImgInput}
                      />
                    </div>
                  )} */}
                    {/* {tab === "notification" && (
                      <div className="tab-item">
                        <NotificationSettingTab />
                      </div>
                    )} */}

                  {/* {tab === "payment" && (
                    <div className="tab-item">
                      <PaymentMathodsTab />
                    </div>
                  )}
                  {tab === "faq" && <FaqTab datas={faqData} />}
                  {tab === "terms" && <TermsConditionTab />} */}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
